import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Globe } from 'lucide-react';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-[#3C3B6E] text-white" data-testid="footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {/* Brand */}
                    <div className="lg:col-span-1">
                        <Link to="/" className="flex items-center gap-2 mb-4" data-testid="footer-logo">
                            <div className="w-10 h-10 bg-[#B22234] rounded-lg flex items-center justify-center">
                                <Globe className="w-6 h-6 text-white" />
                            </div>
                            <span className="font-black text-xl tracking-tight text-white">
                                BIONEXX LLC
                            </span>
                        </Link>
                        <p className="text-white/70 text-sm leading-relaxed">
                            Delivering high-quality products and professional IT services to clients across the globe.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-semibold text-sm uppercase tracking-[0.2em] mb-4 text-[#B22234]">
                            Quick Links
                        </h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-white/70 hover:text-[#B22234] text-sm transition-colors" data-testid="footer-link-home">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/about" className="text-white/70 hover:text-[#B22234] text-sm transition-colors" data-testid="footer-link-about">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-white/70 hover:text-[#B22234] text-sm transition-colors" data-testid="footer-link-services">
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link to="/#digital-assets" className="text-white/70 hover:text-[#B22234] text-sm transition-colors" data-testid="footer-link-digital-assets">
                                    Digital Assets
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-white/70 hover:text-[#B22234] text-sm transition-colors" data-testid="footer-link-contact">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h4 className="font-semibold text-sm uppercase tracking-[0.2em] mb-4 text-[#B22234]">
                            Services
                        </h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/services" className="text-white/70 hover:text-[#B22234] text-sm transition-colors">
                                    Software Development
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-white/70 hover:text-[#B22234] text-sm transition-colors">
                                    App Development
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-white/70 hover:text-[#B22234] text-sm transition-colors">
                                    IT Consulting
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-white/70 hover:text-[#B22234] text-sm transition-colors">
                                    Export Solutions
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="font-semibold text-sm uppercase tracking-[0.2em] mb-4 text-[#B22234]">
                            Contact Us
                        </h4>
                        <ul className="space-y-3">
                            <li className="flex items-start gap-3">
                                <Phone className="w-4 h-4 text-[#B22234] mt-0.5 flex-shrink-0" />
                                <a href="tel:+15022895604" className="text-white/70 hover:text-[#B22234] text-sm transition-colors" data-testid="footer-phone">
                                    +1 502-289-5604
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="w-4 h-4 text-[#B22234] mt-0.5 flex-shrink-0" />
                                <a href="mailto:info@bionexxllc.com" className="text-white/70 hover:text-[#B22234] text-sm transition-colors" data-testid="footer-email">
                                    info@bionexxllc.com
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 text-[#B22234] mt-0.5 flex-shrink-0" />
                                <span className="text-white/70 text-sm" data-testid="footer-address">
                                    271 W. Short St Ste 410 #2627,<br />
                                    Lexington, Kentucky 40507, USA
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-white/20 mt-12 pt-8">
                    <p className="text-center text-white/50 text-sm" data-testid="footer-copyright">
                        &copy; {currentYear} BIONEXX LLC &ndash; All Rights Reserved
                    </p>
                </div>
            </div>
        </footer>
    );
};
